<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->
<template>
  <div class="profit-loss-drill-through-main">
    <div class="drill-through-body">
      <TableBox
        :title="tableTitle"
        :tableData.sync="drillThroughTableData"
        :maxSelection="0"
        :hideColumns="hideColumns"
        :dataType="tableDataType"
        :loading="drillThroughTableLoading"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      tableTitle: '',
      drillThroughTableData: [],
      hideColumns: ['Operation'],
      tableDataType: {},
      drillThroughTableLoading: false,
    };
  },
  props: {},
  methods: {
    getTableData: async function (requestBody) {
      this.$fullscreenLoading(`Getting ${requestBody.rpttype.includes('TXN') ? 'Transaction' : 'Details'}`);
      const response = await this.$apiCallV2('/HQConsolidatedProfitLoss/GetPNLAnalysis', requestBody);
      if (!response || response.length === 0) {
        this.$fullscreenLoading();
        return;
      }
      let formattedData = [];
      if (requestBody.rpttype.includes('DETAILS')) {
        const start = new Date(requestBody['startdate']).formatString('dd/MM/yy');
        const end = new Date(requestBody['enddate']).formatString('dd/MM/yy');
        const dateRangeKey = `${start}-${end}`;
        this.hideColumns.push(dateRangeKey);

        formattedData = response.map((item) => {
          return {
            PNLSeq: item['PNLSeq'],
            'GL Account No.': item['Operation'],
            Description: item[dateRangeKey],
            ...item,
          };
        });

        Object.keys(formattedData[0]).forEach((key) => {
          if (!['PNLSeq', 'GL Account No.', 'Description', 'Operation', dateRangeKey].includes(key)) {
            this.tableDataType[key] = 'currency';
          }
        });
      } else if (requestBody.rpttype.includes('TXN')) {
        this.tableDataType = {
          'Txn Date': 'date',
          Amount: 'currency',
        };

        formattedData = response.map((item) => {
          return {
            'Branch-Department': item['Br-Dept'],
            'Txn Date': item['Txn Date'],
            'Txn Type': item['Txn'],
            'Ref #': item['Ref #'],
            'Cheque/AP Invoice #': item['Cheque/APInv #'],
            'Debtor Code': item['debtor'],
            'Debtor Name': item['debtorname'],
            'Creditor Code': item['creditor'],
            'Creditor Name': item['creditorname'],
            'Debit Ac.': item['Dr'],
            'Credit Ac': item['Cr'],
            Amount: item['Amount'],
            'Batch #': item['Batch #'],
            'Debit Subgroup': item['Dr Subgroup'],
            'Debit Report': item['Dr Rpt'],
            'Credit Subgroup': item['Cr Subgroup'],
            'Credit Report': item['Cr Rpt'],
          };
        });
      }

      this.$fullscreenLoading();
      this.$nextTick(() => {
        this.drillThroughTableData = formattedData || response;
      });
    },
  },
  async mounted() {
    const details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName + '_HQPNL'));

    const drillThroughType = this.$route.params.drillThroughName.match(/\(([^)]+)\)/)[1];
    const drillThroughItem = details.series;

    this.tableTitle = `${drillThroughItem ? drillThroughItem + ' - ' : ''}${drillThroughType}`;

    this.drillThroughTableLoading = true;
    await this.getTableData(details.data);
    this.drillThroughTableLoading = false;
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.profit-loss-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;

  > .drill-through-body {
    background-color: white;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>
